import type { CollectionRulesInput } from '@nucleus-commerce/api-client/admin';

import type { CollectionListParams } from '../api/collections-api';

/** Store-scoped keys: switching stores never shares cache. */
export const collectionKeys = {
  all: (storeId: string) => ['stores', storeId, 'collections'] as const,
  lists: (storeId: string) => [...collectionKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: CollectionListParams) =>
    [...collectionKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...collectionKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...collectionKeys.details(storeId), id] as const,
  products: (storeId: string, id: string) =>
    [...collectionKeys.detail(storeId, id), 'products'] as const,
  /** Every product-side membership view of the store; invalidated when a collection's list changes. */
  forProducts: (storeId: string) => [...collectionKeys.all(storeId), 'product'] as const,
  forProduct: (storeId: string, productId: string) =>
    [...collectionKeys.forProducts(storeId), productId] as const,
  preview: (storeId: string, rules: CollectionRulesInput) =>
    [...collectionKeys.all(storeId), 'preview', rules] as const,
};
